import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjects } from "../../Projects/redux/projectThunk";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExistingProject = ({ onSubmit, projectData }) => {
  const dispatch = useDispatch();
  const { allProjects: data, loading } = useSelector((state) => state.project);

  const [checked, setChecked] = useState({});
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    dispatch(fetchProjects());
  }, [dispatch]);

  useEffect(() => {
    if (projectData && projectData.length > 0 && projectData[0].details) {
      try {
        const savedProjects = JSON.parse(projectData[0].details);

        const newChecked = {};
        savedProjects.forEach((proj) => {
          if (!newChecked[proj.eventId]) newChecked[proj.eventId] = {};
          newChecked[proj.eventId][proj.projectId] = true;
        });

        setChecked(newChecked);
      } catch (err) {
        console.error("❌ Error parsing details JSON:", err);
      }
    }
  }, [projectData]);

  const handleCheck = (eventId, projectId) => {
    setChecked((prev) => ({
      ...prev,
      [eventId]: {
        ...prev[eventId],
        [projectId]: !prev[eventId]?.[projectId],
      },
    }));
  };

  const handleAccordionChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const getSelectedProjects = () => {
    const selected = [];

    data.forEach((event) => {
      event.projects.forEach((proj) => {
        if (checked[event.event_id]?.[proj.id]) {
          selected.push({
            eventId: event.event_id,
            eventName: event.event_details,
            projectId: proj.id,
            projectName: proj.project_name,
            projectDescription: proj.project_description,
          });
        }
      });
    });

    return selected;
  };

  if (loading) return <p>Loading...</p>;

  return (
    <Box sx={{ width: "95%", margin: "auto", maxWidth: "1000px" }}>
      {data.map((event) => (
        <Accordion
          key={event.event_id}
          expanded={expanded === event.event_id}
          onChange={handleAccordionChange(event.event_id)}
          sx={{ mb: 1, boxShadow: 1, "&:before": { display: "none" } }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "rgba(0, 150, 136, 0.1)",
              minHeight: "40px !important",
              "& .MuiAccordionSummary-content": { margin: 0 },
            }}
          >
            <Typography fontWeight="bold" fontSize="15px">
              {event.event_details || "No Event Name"}
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ p: 1 }}>
            {event.projects.map((proj) => (
              <Box
                key={proj.id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mb: 1,
                  p: 1,
                  borderRadius: "6px",
                  backgroundColor: "rgba(0, 123, 255, 0.05)",
                }}
              >
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={checked[event.event_id]?.[proj.id] || false}
                      onChange={() => handleCheck(event.event_id, proj.id)}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                      {proj.project_name}
                    </Typography>
                  }
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ ml: 4, fontSize: "13px", mt: 0.3 }}
                >
                  {proj.project_description}
                </Typography>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}

      <Box textAlign="center" mt={2}>
        <Button
          variant="contained"
          color="primary"
          sx={{ px: 4, fontSize: "14px", textTransform: "none" }}
          onClick={() => onSubmit(getSelectedProjects())}
        >
          {projectData?.length > 0 ? "Update" : "Submit"}
        </Button>
      </Box>
    </Box>
  );
};

export default ExistingProject;
